import {
  Component,
  Input,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
  HostListener,
  Output,
  EventEmitter,
} from '@angular/core';
import { EaDisplay, EaSize } from '@app/components/pr-display';
declare var $: any;

@Component({
    selector: 'pr-button-dropdown',
    templateUrl: './pr-button-dropdown.component.html',
    styleUrls: ['./pr-button-dropdown.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PrButtonDropdownComponent {
  private opened: boolean = false;

  @Input() display: EaDisplay;
  @Input() size: EaSize;
  @Input() clazz: string;
  @Input() btnClass: string;
  @Input() icon: string;
  @Input() expandIcon: string;
  @Input() tooltip: string;
  @Input() label: string;
  @Output() onOpened: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('dropdown', { static: true }) dropdown: ElementRef;

  constructor(private el: ElementRef) {}

  ngOnInit() {}

  toggle() {
    if (this.opened) this.close();
    else this.open();
  }

  open() {
    this.opened = true;
    this.dropdown.nativeElement.classList.add('display');
    setTimeout(() => this.dropdown.nativeElement.classList.add('open'), 100);
    this.onOpened.emit();
  }

  close() {
    this.opened = false;
    this.dropdown.nativeElement.classList.remove('open');
    setTimeout(
      () => this.dropdown.nativeElement.classList.remove('display'),
      100,
    );
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.close();
    }
  }
}
